import { render, staticRenderFns } from "./PhoneVerifyModal.vue?vue&type=template&id=02f975fe&scoped=true&"
import script from "./PhoneVerifyModal.vue?vue&type=script&lang=ts&"
export * from "./PhoneVerifyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f975fe",
  null
  
)

export default component.exports